// extracted by mini-css-extract-plugin
export default {"container":"Cross_container__9s2f4","line":"Cross_line__gk0yc","vertical":"Cross_vertical__-0O0A","horizontal":"Cross_horizontal__UXAbN"};